import { __decorate } from "tslib";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NavPaneContentComponent } from "./nav-pane-content/nav-pane-content.component";
import { MatIconModule } from "@angular/material/icon";
import { NavComponent } from "./nav.component";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NavToolbarContentComponent } from "./nav-toolbar-content/nav-toolbar-content.component";
import { NavNotificationsComponent } from "./nav-notifications/nav-notifications.component";
import { ClickOutsideDirective } from "./shared/clic-outside.directive";
import { MatTabsModule } from "@angular/material/tabs";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { ModuleLinkPipe } from "./shared/module-link/module-link.pipe";
import { SettingLinksWithModulePipe } from "./shared/setting-links.pipe";
import { AdminLinksWithOrganisationPipe } from "./shared/admin-links-with-organisation.pipe";
let NavModule = class NavModule {
};
NavModule = __decorate([
    NgModule({
        declarations: [NavComponent,
            NavPaneContentComponent,
            NavToolbarContentComponent,
            NavNotificationsComponent,
            ClickOutsideDirective,
            ModuleLinkPipe,
            SettingLinksWithModulePipe,
            AdminLinksWithOrganisationPipe],
        exports: [NavComponent],
        imports: [
            CommonModule,
            MatIconModule,
            RouterModule,
            MatButtonModule,
            MatSidenavModule,
            MatToolbarModule,
            MatTabsModule,
            NgbAccordionModule,
            MatTooltipModule
        ]
    })
], NavModule);
export { NavModule };
